// Import dependencies
import React, {Component} from 'react';

// Import css
import './Grid.css';

export default class Grid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentHorizontal: [],
            currentVertical: [],
            isActive: ''
        };
        this.focus = this.focus.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);
    }

    // Calculate & Update state of new dimensions
    updateDimensions() {
        if (window.innerWidth > 1025) {
            this.setState({
                currentHorizontal: [ 0, 0, window.innerHeight*.31, window.innerHeight*.69, window.innerHeight, window.innerHeight+100 ],
                currentVertical: [ 0, window.innerWidth*.15, window.innerWidth*.38, window.innerWidth*.62, window.innerWidth*.85, window.innerWidth],
                isActive: ''
            });
        }
        else if (window.innerWidth > 650) {
            this.setState({
                currentHorizontal: [ 0, 0, window.innerHeight*.17, window.innerHeight*.50, window.innerHeight*.83, window.innerHeight ],
                currentVertical: [ 0, window.innerWidth*.15, window.innerWidth*.38, window.innerWidth*.62, window.innerWidth*.85, window.innerWidth ],
                isActive: ''
            });
        }
        else if (window.innerWidth < 650) {
            this.setState({
                currentHorizontal: [ 0, 0, window.innerHeight*.17, window.innerHeight*.50, window.innerHeight*.83, window.innerHeight ],
                currentVertical: [ 0, 0, window.innerWidth*.3, window.innerWidth*.68, window.innerWidth, window.innerWidth ],
                isActive: ''
            });
        }
    }

    // Focus a particular element with the grid
    focus(top, bottom, left, right) {
        // Get closest coordinates on the grid
        let topLoc = this.state.currentHorizontal.indexOf(this.state.currentHorizontal.reduce((prev, curr) => Math.abs(curr - top) < Math.abs(prev - top) ? curr : prev));
        let bottomLoc = this.state.currentHorizontal.indexOf(this.state.currentHorizontal.reduce((prev, curr) => Math.abs(curr - bottom) < Math.abs(prev - bottom) ? curr : prev));
        let leftLoc = this.state.currentVertical.indexOf(this.state.currentVertical.reduce((prev, curr) => Math.abs(curr - left) < Math.abs(prev - left) ? curr : prev));
        let rightLoc = this.state.currentVertical.indexOf(this.state.currentVertical.reduce((prev, curr) => Math.abs(curr - right) < Math.abs(prev - right) ? curr : prev));

        // Update grid
        let vertical = this.state.currentVertical;
        let horizontal = this.state.currentHorizontal;

        // Check if closest value is the same
        if (topLoc === bottomLoc) {
            horizontal[topLoc-1] = top;
            horizontal[bottomLoc] = bottom;
        }
        else {
            horizontal[topLoc] = top;
            horizontal[bottomLoc] = bottom;
        }

        if (leftLoc === rightLoc) {
            vertical[leftLoc] = left;
            vertical[rightLoc+1] = right;
        }
        else {
            vertical[leftLoc] = left;
            vertical[rightLoc] = right;
        }

        // Update state
        this.setState({
            currentHorizontal: horizontal,
            currentVertical: vertical,
            isActive: 'is-active'
        });
    }

    componentDidMount() {
        // Update window dimensions and listen for changes
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));
    }

    componentWillUnmount() {
        // Remove window resize listener
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    render() {
        return (
            <div data-v-a4897a32="" data-v-ac11fecc="" className={"grid "+this.state.isActive}>
                <div data-v-a4897a32="" className="parallax" style={{transform: 'translateY('+this.state.currentHorizontal[0]+'px)'}}>
                    <div data-v-a4897a32="" className="line horizontal" style={{transform: 'translateY('+this.state.currentHorizontal[1]+'px)'}}>
                        <div data-v-a4897a32="" className="inner">
                            <div data-v-a4897a32="" className="gradient gradient-0" />
                            <div data-v-a4897a32="" className="gradient gradient-1" />
                        </div>
                    </div>
                    <div data-v-a4897a32="" className="line horizontal" style={{transform: 'translateY('+this.state.currentHorizontal[2]+'px)'}}>
                        <div data-v-a4897a32="" className="inner">
                            <div data-v-a4897a32="" className="gradient gradient-0" />
                            <div data-v-a4897a32="" className="gradient gradient-1" />
                        </div>
                    </div>
                    <div data-v-a4897a32="" className="line horizontal" style={{transform: 'translateY('+this.state.currentHorizontal[3]+'px)'}}>
                        <div data-v-a4897a32="" className="inner">
                            <div data-v-a4897a32="" className="gradient gradient-0" />
                            <div data-v-a4897a32="" className="gradient gradient-1" />
                        </div>
                    </div>
                    <div data-v-a4897a32="" className="line horizontal" style={{transform: 'translateY('+this.state.currentHorizontal[4]+'px)'}}>
                        <div data-v-a4897a32="" className="inner">
                            <div data-v-a4897a32="" className="gradient gradient-0" />
                            <div data-v-a4897a32="" className="gradient gradient-1" />
                        </div>
                    </div>
                    <div data-v-a4897a32="" className="line horizontal" style={{transform: 'translateY('+this.state.currentHorizontal[5]+'px)'}}>
                        <div data-v-a4897a32="" className="inner">
                            <div data-v-a4897a32="" className="gradient gradient-0" />
                            <div data-v-a4897a32="" className="gradient gradient-1" />
                        </div>
                    </div>
                </div>
                <div data-v-a4897a32="" className="line vertical" style={{transform: 'translateX('+this.state.currentVertical[0]+'px)'}}>
                    <div data-v-a4897a32="" className="inner">
                        <div data-v-a4897a32="" className="gradient gradient-0" />
                        <div data-v-a4897a32="" className="gradient gradient-1" />
                    </div>
                </div>
                <div data-v-a4897a32="" className="line vertical" style={{transform: 'translateX('+this.state.currentVertical[1]+'px)'}}>
                    <div data-v-a4897a32="" className="inner">
                        <div data-v-a4897a32="" className="gradient gradient-0" />
                        <div data-v-a4897a32="" className="gradient gradient-1" />
                    </div>
                </div>
                <div data-v-a4897a32="" className="line vertical" style={{transform: 'translateX('+this.state.currentVertical[2]+'px)'}}>
                    <div data-v-a4897a32="" className="inner">
                        <div data-v-a4897a32="" className="gradient gradient-0" />
                        <div data-v-a4897a32="" className="gradient gradient-1" />
                    </div>
                </div>
                <div data-v-a4897a32="" className="line vertical" style={{transform: 'translateX('+this.state.currentVertical[3]+'px)'}}>
                    <div data-v-a4897a32="" className="inner">
                        <div data-v-a4897a32="" className="gradient gradient-0" />
                        <div data-v-a4897a32="" className="gradient gradient-1" />
                    </div>
                </div>
                <div data-v-a4897a32="" className="line vertical" style={{transform: 'translateX('+this.state.currentVertical[4]+'px)'}}>
                    <div data-v-a4897a32="" className="inner">
                        <div data-v-a4897a32="" className="gradient gradient-0" />
                        <div data-v-a4897a32="" className="gradient gradient-1" />
                    </div>
                </div>
                <div data-v-a4897a32="" className="line vertical" style={{transform: 'translateX('+this.state.currentVertical[5]+'px)'}}>
                    <div data-v-a4897a32="" className="inner">
                        <div data-v-a4897a32="" className="gradient gradient-0" />
                        <div data-v-a4897a32="" className="gradient gradient-1" />
                    </div>
                </div>
            </div>
        );
    }
}
